/**
 * Utilitário de CPF. Espelha o objeto de valor Cpf do backend.
 *
 * Contém apenas regras de CPF. Para CNPJ use `cnpj.js`; para documentos
 * que podem ser CPF ou CNPJ use `cpfCnpj.js`.
 */

const REGEX_APENAS_DIGITOS = /[^0-9]/g

/**
 * Remove do CPF tudo que não for dígito. Retorna null para valor nulo ou
 * vazio; string vazia quando não houver dígitos.
 *
 * @param {string|number|null|undefined} valor
 * @returns {string|null}
 */
export const normalizarCpf = (valor) => {
  if (valor === null || valor === undefined || valor === '') {
    return null
  }

  return valor.toString().replace(REGEX_APENAS_DIGITOS, '')
}

export default {
  normalizarCpf
}
